<template>
  <div id="" class="">
      <el-dialog :title="dialogTitle" :visible.sync="isShowdialog" @closed="beforeClose" top="5vh" @open="beforeOpen" width="60%">

        <el-tabs v-model="activeName" type="card" v-if="dialogTitle === '信息展示' ">
          <el-tab-pane label="基础信息" name="first">
            <div>
              <!-- 生成二维码 -->
              <!-- <div style="position:absolute;bottom:2%;right: 5%;z-index: 999;" >
                <qr-code :text="productData._id" />
              </div> -->

              <el-descriptions :column="3" border>
                <el-descriptions-item label="商品目录">
                  <el-tag size="small">{{ productData.category || '空'}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="商品名称">
                  <div>{{ productData.name || '空'  }}</div>
                </el-descriptions-item>
                <el-descriptions-item label="上架时间">
                  <div>{{ $util.formatDate(productData.createdAt) || '空'  }}</div>
                </el-descriptions-item>
                <el-descriptions-item label="修改时间">
                  <div>{{ $util.formatDate(productData.updatedAt) || '空'  }}</div>
                </el-descriptions-item>


                <el-descriptions-item label="是否上架">
                  <el-tag size="small">{{ productData.status || '空' }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="商品单价">
                  <el-tag size="small">{{ productData.price || '空' }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="库存信息">
                  <el-tag size="small">{{ productData.stock || '空' }}</el-tag>
                </el-descriptions-item>


                <el-descriptions-item label="商品介绍">
                  <div>{{ productData.description || '空' }}</div>
                </el-descriptions-item>
              </el-descriptions>

            </div>
          </el-tab-pane>

          <el-tab-pane label="图片信息" name="second">
            <div>
              <!-- 商品封面图片 -->
              <el-descriptions :column="1">
                <el-descriptions-item label="封面图片">
                </el-descriptions-item>
              </el-descriptions>
              <div style="display:flex;">
                <div v-for="(item,index) in coverImage" :key="index" style="margin-right:10px">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.url"
                    :preview-src-list="[String(item.url)]">
                  </el-image>
                </div>
              </div>

              <!-- 商品轮播图 -->
              <el-descriptions :column="1">
                <el-descriptions-item label="轮播图片"></el-descriptions-item>
              </el-descriptions>
              <div style="display:flex;">
                <div v-for="(item,index) in images" :key="index" style="margin-right:10px">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.url"
                    :preview-src-list="[String(item.url)]">
                  </el-image>
                </div>
              </div>

              <!-- 商品详情图 -->
              <el-descriptions :column="1">
                <el-descriptions-item label="详情图片">
                </el-descriptions-item>
              </el-descriptions>
              <div style="display:flex;">
                <div v-for="(item,index) in contentImage" :key="index" style="margin-right:10px">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item.url"
                    :preview-src-list="[String(item.url)]">
                  </el-image>
                </div>
              </div>

            </div>
          </el-tab-pane>

          <div style="display: flex;justify-content: space-around;margin-top: 10px;">
            <el-button @click="isShowdialog = false" style="width: 150px">取 消</el-button>
          </div>
        </el-tabs>

        <el-dialog :visible.sync="ImageDialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>


        <account v-if="dialogTitle !== '信息展示'" ref="accountDialog" :type="dialogTitle" :product="product" @state-change="accountStateChange"></account>
      </el-dialog>
  </div>
</template>
<script>
import AccountComponent from '@/components/instrument/AccountComponent.vue'
//import QrCode from '@/components/tools/QrCode.vue'
export default {
  components: {
    'account': AccountComponent,
    //QrCode
  },
  props:['dialogVisible','dTitle','product'],
  watch: {
    dialogVisible(val){
      this.isShowdialog = val;
    },
    dTitle(val){
      this.dialogTitle = val;
    },
    product(val){
      if(!this.$util.isEmpty(val)){
        this.productData = val

        this.coverImage = [{
          name: this.product.coverImage,
          url: this.$config.product_image_url + 'cover_image/' + this.product.coverImage
        }];
        this.contentImage = [{
          name: this.product.contentImage,
          url: this.$config.product_image_url + 'content_image/' + this.product.contentImage
        }];

        let images = [];
        this.product.images && this.product.images.forEach(image => {
          images.push({
            name: image,
            url: this.$config.product_image_url + 'images/' + image
          });
        })
        this.images = images;
      }
    },
  },
  data() {
    return {
      activeName: 'first',
      productData: {},

      coverImage: [], //封面图片
      images: [], //轮播图片
      contentImage: [], //内容图片

      dialogImageUrl: '',
      ImageDialogVisible: false,

      isShowdialog: false,
      dialogTitle: '',
      operationsList: [],
      loading: false,

      isCancel: true,
    }
  },
  methods:{
    accountStateChange(val){
      this.isCancel = val.isCancel;
      this.isShowdialog = false;
    },

    beforeClose(){
      //console.log('isCancel: ' + this.isCancel);
      if(this.dialogTitle !== '信息展示'){
        this.$refs.accountDialog.beforeClose();
      }
      this.isShowdialog = false;
      if(this.isCancel)
        this.$emit('change-state',{isShow: this.isShowdialog,dialog:'account'})
      else
        this.$emit('change-state',{isShow: this.isShowdialog,dialog:'account',refresh: true})
    },

    async beforeOpen(){

    },

    // outPutResume(){
    //   this.$confirm("是否下载当前设备履历",'提示',{
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(async () => {
    //     let options = {
    //       newMachineNO: this.machineData.newMachineNO
    //     }
    //     let result = await this.$equipmentdata.downloadFile("resume",options);
    //     let title = "";
    //     let contentype = {};
    //     title = "仪器设备履历表.docx";
    //     contentype = {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'}
    //     //console.log(result);
    //     this.$FileSaver.saveAs(
    //       new Blob([result], contentype),
    //       title
    //     );
    //   })
    // },

  },
}
</script>

<style>
.no-input{
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/EquipmentAccountDialog.vue